export const isIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ") > -1;
  const msie11 = ua.indexOf("Trident/") > -1;

  // If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
  const isEdge = ua.indexOf("Edge/") > -1;


  return msie || msie11 || isEdge;
};

interface paramModel {
  [key: string]: any;
}
export const isSafari=()=>{
  if(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)){
    return true;
  }else{
    return false;
  }
  // var Sys:any = {};
  // var ua = navigator.userAgent.toLowerCase();
  // var s :any={};
  // (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
  // (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
  // (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
  // (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
  // (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
  // //以下进行测试
  // if (Sys.ie) console.log('IE: ' + Sys.ie);
  // if (Sys.firefox) console.log('Firefox: ' + Sys.firefox);
  // if (Sys.chrome) console.log('Chrome: ' + Sys.chrome);
  // if (Sys.opera) console.log('Opera: ' + Sys.opera);
  // if (Sys.safari) console.log('Safari: ' + Sys.safari);
}
export const RemoveInvalidProps = (params: paramModel): paramModel => {
  const newParams = params;
  Object.keys(newParams).forEach((k) => {
    const hasProps = Object.prototype.hasOwnProperty.call(newParams, k);
    let v = '';
    if (typeof newParams[k] !== 'undefined' && newParams[k] !== null) {
      v = String.prototype.trim.call(newParams[k]) || "";
    }

    if (!hasProps || (hasProps && v === "")) {
      delete newParams[k];
    }
  });

  return newParams;
}

export const IsValid = (value: string): boolean => {
  const isBlank = value === '';
  const isNull = value === null;
  const isUndefined = typeof value === 'undefined';
  return !isBlank && !isNull && !isUndefined;
}

export const BlobFileTypes = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
}
export const stringContaint = (value: string, conStr: string) => {
  // let str = ['', ...value.split(''), ''].join('.*'); //转化成正则格式的字符串
  let str = `.*${value}`;
  let reg = new RegExp(str); //正则
  var bol = reg.test(conStr);
  return bol  //去匹配待查询的字符串
}